// BuildersLab Business, for the screens. Every plan, price, country and rule
// comes from builderslab/shared/business.json, the same file the server
// charges from, so a price on the screen is the price charged. Prices the
// client actually pays are quoted by the server (/api/business/plans), in
// their own currency; the list prices here are only ever shown as such.

import BUSINESS from '../../builderslab/shared/business.json';

export { BUSINESS };

export const COUNTRY_CODES = Object.keys(BUSINESS.countries);

/** The company's name as the registry writes it: "Adire Lane Ltd". */
export function legalName(name, entity, { long = false } = {}) {
  const base = String(name || '').trim();
  const spec = BUSINESS.entityTypes[entity];
  const suffix = spec ? (long ? spec.longSuffix : spec.suffix) : '';
  if (!suffix || !base) return base;
  if (new RegExp(`\\b(${spec.suffix}|${spec.longSuffix})\\.?$`, 'i').test(base)) return base;
  return `${base} ${suffix}`;
}

export function entityLabel(entity) {
  return BUSINESS.entityTypes[entity]?.label || entity;
}

/** ₦299,000 or $499: whole naira, dollars to the cent only when there are cents. */
export function formatMoney(amount, currency) {
  const n = Number(amount) || 0;
  if (currency === 'NGN') return `₦${n.toLocaleString('en-NG', { maximumFractionDigits: 0 })}`;
  return `$${n.toLocaleString('en-US', { minimumFractionDigits: n % 1 ? 2 : 0, maximumFractionDigits: 2 })}`;
}

/** The registry, as a founder reads it: "CAC", "Companies House", "the state". */
export function registryName(country) {
  return country === 'NG' ? 'CAC' : country === 'UK' ? 'Companies House' : 'the state';
}

/** The build's tiles, in order (services/business/build.js KINDS). */
export const TILES = [
  { kind: 'brand', label: 'Brand' },
  { kind: 'website', label: 'Website' },
  { kind: 'domain', label: 'Domain & email' },
  { kind: 'social', label: 'Social pages' },
  { kind: 'ads', label: 'Ad creatives' },
  { kind: 'cards', label: 'Business cards' },
  { kind: 'competitors', label: 'Competitors' },
  { kind: 'documents', label: 'Documents' },
  { kind: 'launch_plan', label: 'Launch plan' },
];

/** What becomes official once the company is registered: the build page's bottom row. */
export function officialTiles(country) {
  const c = BUSINESS.countries[country] || BUSINESS.countries.NG;
  return [
    { label: `${c.registry === 'the state' ? 'State' : c.registry} registration`, detail: 'Filed by an accredited agent' },
    { label: `Tax ID (${c.taxId})`, detail: country === 'NG' ? 'Comes with the certificate' : 'Applied for after registration' },
    { label: 'Payments', detail: country === 'NG' ? 'Flutterwave and NOWPayments' : 'Stripe and NOWPayments' },
  ];
}

export const NG_STATES = [
  'Abia', 'Adamawa', 'Akwa Ibom', 'Anambra', 'Bauchi', 'Bayelsa', 'Benue', 'Borno', 'Cross River', 'Delta',
  'Ebonyi', 'Edo', 'Ekiti', 'Enugu', 'FCT (Abuja)', 'Gombe', 'Imo', 'Jigawa', 'Kaduna', 'Kano', 'Katsina',
  'Kebbi', 'Kogi', 'Kwara', 'Lagos', 'Nasarawa', 'Niger', 'Ogun', 'Ondo', 'Osun', 'Oyo', 'Plateau', 'Rivers',
  'Sokoto', 'Taraba', 'Yobe', 'Zamfara',
];

export const US_STATES = [
  'Alabama', 'Alaska', 'Arizona', 'Arkansas', 'California', 'Colorado', 'Connecticut', 'Delaware',
  'District of Columbia', 'Florida', 'Georgia', 'Hawaii', 'Idaho', 'Illinois', 'Indiana', 'Iowa', 'Kansas',
  'Kentucky', 'Louisiana', 'Maine', 'Maryland', 'Massachusetts', 'Michigan', 'Minnesota', 'Mississippi',
  'Missouri', 'Montana', 'Nebraska', 'Nevada', 'New Hampshire', 'New Jersey', 'New Mexico', 'New York',
  'North Carolina', 'North Dakota', 'Ohio', 'Oklahoma', 'Oregon', 'Pennsylvania', 'Rhode Island',
  'South Carolina', 'South Dakota', 'Tennessee', 'Texas', 'Utah', 'Vermont', 'Virginia', 'Washington',
  'West Virginia', 'Wisconsin', 'Wyoming',
];
